import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { ResourceDirectory } from './components/ResourceDirectory';
import { NewsSection } from './components/NewsSection';
import { EventsCalendar } from './components/EventsCalendar';
import { NextMeeting } from './components/NextMeeting';
import { OfficialResources } from './components/OfficialResources';
import { TranslationProvider } from './components/TranslationProvider';
import { ServiceNotice } from './components/ServiceNotice';
import { LiveTraffic } from './components/LiveTraffic';
import { WeatherBanner } from './components/WeatherBanner';
import { Facebook, Instagram, Sparkles } from 'lucide-react';
export function App() {
  return <TranslationProvider data-id="element-0">
      <div id="top" className="min-h-screen font-sans text-gray-900 bg-white selection:bg-sky selection:text-white" data-id="element-1">
        <Navbar data-id="element-2" />
        {/* Aviso de servicios oficiales (inglés/español) — debajo del encabezado */}
        <ServiceNotice data-id="element-3" />
        <WeatherBanner data-id="element-4" />
        <main data-id="element-5">
          <Hero data-id="element-6" />

          {/* Directorio Telefónico Digital y Accesible (Reemplaza al libro 3D) */}
          <ResourceDirectory data-id="element-7" />

          <NewsSection data-id="element-8" />
          <LiveTraffic data-id="element-9" />
          <EventsCalendar data-id="element-10" />
          <NextMeeting data-id="element-11" />
          <OfficialResources data-id="element-12" />
        </main>

        <footer className="bg-charcoal-dark text-softblue-dark py-12 text-center text-sm border-t-4 border-sylmar" data-id="element-13">
          <div className="max-w-4xl mx-auto px-6 flex flex-col items-center" data-id="element-14">
            <div className="flex items-center justify-center mb-8" data-id="element-15">
              <img src="https://cdn.magicpatterns.com/uploads/b19k3B7qcY9GvykkPkXLub/ChatGPT_Image_2_jul_2026,_00_15_36.png" alt="Sylmar Neighborhood Council" className="h-24 object-contain notranslate" data-id="element-16" />
            </div>

            {/* Redes Sociales Oficiales */}
            <div className="flex flex-col items-center mb-8" data-id="element-17">
              {/* Llamado a la acción con destellos */}
              <div className="flex items-center gap-2 mb-4" data-id="element-18">
                <Sparkles className="w-4 h-4 text-warm animate-[twinkle_1.6s_ease-in-out_infinite]" data-id="element-19" />
                <p className="text-warm font-bold uppercase tracking-widest text-xs" data-id="element-20">
                  ¡Síguenos!
                </p>
                <span className="text-softblue-dark/60 text-xs italic" data-id="element-21">
                  Follow us
                </span>
                <Sparkles className="w-4 h-4 text-warm animate-[twinkle_1.6s_ease-in-out_infinite_0.8s]" data-id="element-22" />
              </div>

              <div className="flex gap-6" data-id="element-23">
                {/* Facebook Oficial */}
                <a href="https://www.facebook.com/sylmarnc/" target="_blank" rel="noopener noreferrer" className="group relative overflow-hidden bg-[#1877F2] text-white p-4 rounded-full shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-[0_0_25px_rgba(24,119,242,0.7)] animate-[socialGlow_3s_ease-in-out_infinite]" aria-label="Facebook Oficial del Sylmar Neighborhood Council" data-id="element-24">
                  <span className="pointer-events-none absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-700 bg-gradient-to-r from-transparent via-white/60 to-transparent skew-x-12" data-id="element-25"></span>
                  <span className="pointer-events-none absolute inset-0 -translate-x-full animate-[shimmer_3.5s_ease-in-out_infinite] bg-gradient-to-r from-transparent via-white/30 to-transparent skew-x-12" data-id="element-26"></span>
                  <Facebook className="w-6 h-6 fill-current relative z-10" data-id="element-27" />
                  <Sparkles className="w-3 h-3 text-white absolute -top-0.5 -right-0.5 z-10 animate-[twinkle_2s_ease-in-out_infinite]" data-id="element-28" />
                </a>

                {/* Instagram Oficial */}
                <a href="https://www.instagram.com/sylmar_nc?igsh=NTc4MTIwNjQ2YQ%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" className="group relative overflow-hidden bg-gradient-to-tr from-[#F58529] via-[#DD2A7B] to-[#8134AF] text-white p-4 rounded-full shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-[0_0_25px_rgba(221,42,123,0.7)] animate-[socialGlow_3s_ease-in-out_infinite_1.5s]" aria-label="Instagram Oficial del Sylmar Neighborhood Council" data-id="element-29">
                  <span className="pointer-events-none absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-700 bg-gradient-to-r from-transparent via-white/60 to-transparent skew-x-12" data-id="element-30"></span>
                  <span className="pointer-events-none absolute inset-0 -translate-x-full animate-[shimmer_3.5s_ease-in-out_infinite_1s] bg-gradient-to-r from-transparent via-white/30 to-transparent skew-x-12" data-id="element-31"></span>
                  <Instagram className="w-6 h-6 relative z-10" data-id="element-32" />
                  <Sparkles className="w-3 h-3 text-white absolute -top-0.5 -right-0.5 z-10 animate-[twinkle_2s_ease-in-out_infinite_1s]" data-id="element-33" />
                </a>
              </div>
            </div>

            <p className="text-gray-400" data-id="element-34">
              © {new Date().getFullYear()}{' '}
              <span className="notranslate" data-id="element-35">Sylmar Neighborhood Council</span>.
              Todos los derechos reservados.
            </p>
          </div>
        </footer>
      </div>
    </TranslationProvider>;
}